<template lang="pug">
  ValidationProvider(:rules="rules" v-slot="{ errors }")
    v-select.text-center(:items="items" v-model="valuefield" :disabled="disabled" :error="errors.length > 0" @input="inputFill()")
      template(v-slot:label)
        v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
        | {{ label }}
    span.red--text.text--accent-2(v-if="errors.length > 0")
      v-icon(color="red accent-2") mdi-alert
      |  {{ errors[0] }}
</template>

<script>
  export default {
    name: "BaseSelectField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data:() => ({
      valuefield: null,
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      }
    },
    watch: {
      value: function(val){
        this.valuefield = val;
      }
    },
    created(){
      this.valuefield = this.value;
    },
    methods:{
      inputFill(){
        this.$emit('input', this.valuefield);
      },
    },
  }
</script>

<style lang="sass">
</style>